/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemorySuggestionControllerUpdateMutationRequest, AgentMemorySuggestionControllerUpdateMutationResponse, AgentMemorySuggestionControllerUpdatePathParams, AgentMemorySuggestionControllerUpdate400, AgentMemorySuggestionControllerUpdate401, AgentMemorySuggestionControllerUpdate403, AgentMemorySuggestionControllerUpdate404 } from "../../models/agentMemorySuggestionsController/AgentMemorySuggestionControllerUpdate";

function getAgentMemorySuggestionControllerUpdateUrl(id: AgentMemorySuggestionControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/agent-memory-suggestions/${id}` as const }  
  return res
}

/**
 * @summary Accept or dismiss an agent memory suggestion
 * {@link /api/v1/agent-memory-suggestions/:id}
 */
export async function agentMemorySuggestionControllerUpdate(id: AgentMemorySuggestionControllerUpdatePathParams["id"], data?: AgentMemorySuggestionControllerUpdateMutationRequest, config: Partial<RequestConfig<AgentMemorySuggestionControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<AgentMemorySuggestionControllerUpdateMutationResponse, ResponseErrorConfig<AgentMemorySuggestionControllerUpdate400 | AgentMemorySuggestionControllerUpdate401 | AgentMemorySuggestionControllerUpdate403 | AgentMemorySuggestionControllerUpdate404>, AgentMemorySuggestionControllerUpdateMutationRequest>({ method : "PATCH", url : getAgentMemorySuggestionControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}